export const UPDATE_CURRENT_STEP = "UPDATE_CURRENT_STEP";
export const UPDATE_TASK_DATA = "UPDATE_TASK_DATA";
export const DETECTING_TASK_STATE = "DETECTING_TASK_STATE";
export const IS_NEW_TASK = "IS_NEW_TASK";
export const SIGNIN_DATA = "SIGNIN_DATA";
export const FETCHING_USER_DATA = "FETCHING_USER_DATA";
export const UPDATE_ACTIVE_PIVOT_TAB = "UPDATE_ACTIVE_PIVOT_TAB";
export const SET_LOADING = "SET_LOADING";
export const UPDATE_MAILING_LIST = "UPDATE_MAILING_LIST";
export const INCLUDE_SIGNATURE = "INCLUDE_SIGNATURE";